import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CommonStatus } from "@/Common/Models/Patient/Enum/CommonStatus";

import img_icon_greenmark from "@/Common/_images/Icons/Ramq/GreenCheckmark.png";
import img_icon_house from "@/Common/_images/Icons/Ramq/House.png";
import img_icon_orange_exclamation from "@/Common/_images/Icons/Ramq/OrangeExclamation.png";
import img_icon_orange_question from "@/Common/_images/Icons/Ramq/OrangeQuestion.png";
import img_icon_redexclamation from "@/Common/_images/Icons/Ramq/RedExclamation.png";
import img_icon_redXMark from "@/Common/_images/Icons/Ramq/RedXMark.png";
import Img_icon_notregistered from "@/Common/_images/MSP_NotRegistered.svg";
import Img_icon_registered from "@/Common/_images/MSP_Registered.svg";
import Img_icon_unknown from "@/Common/_images/MSP_Unknown.svg";

interface IStatusComponentProps {
    status: CommonStatus;
    statusInfo: string;
    onClickStatus?: (event: React.MouseEvent) => void;
    isBritishColumbia?: boolean;
    iconWrapperClassName?: string;
}

class StatusComponent extends BaseReactComponent<IStatusComponentProps> {
    private readonly statusIcon: { [status: number]: string } = {
        [CommonStatus.Covered]: img_icon_greenmark,
        [CommonStatus.CoveredOutsideClinic]: img_icon_redXMark,
        [CommonStatus.CoveredWithGroup]: img_icon_house,
        [CommonStatus.CoveredWithAnotherGroup]: img_icon_redXMark,
        [CommonStatus.NotCovered]: img_icon_redXMark,
        [CommonStatus.Question]: img_icon_orange_question,
        [CommonStatus.NoInfo]: img_icon_redexclamation,
        [CommonStatus.Terminated]: img_icon_orange_exclamation
    };

    private getBritishColumbiaStatusIcon(status: CommonStatus): JSX.Element {
        switch (status) {
            case CommonStatus.Covered:
                return <Img_icon_registered />;
            case CommonStatus.NotCovered:
                return <Img_icon_notregistered />;
            case CommonStatus.Question:
                return <Img_icon_unknown />;
            default:
                return <></>;
        }
    }

    constructor(props: IStatusComponentProps) {
        super(props);
    }

    public render(): JSX.Element {
        const clickableClass = this.props.onClickStatus ? "pointer" : "";
        return (
            <div
                className={`${clickableClass} flex-container flex-start align-bottom`}
                onClick={event => this.props.onClickStatus?.(event)}
            >
                {this.props.isBritishColumbia ? (
                    <div className={`align-self-center margin-1px-right ${this.props.iconWrapperClassName}`}>
                        {this.getBritishColumbiaStatusIcon(this.props.status)}
                    </div>
                )
                    : <img className="margin-xs-left" style={{ width: "12px" }} src={this.statusIcon[this.props.status]} />
                }

                <span className="margin-xs-left">
                    {this.props.statusInfo}
                </span>
            </div>
        );
    }
}

export { StatusComponent };
